import React from 'react'

function NatureBasedSo() {
  return (

    <>
      <div className='natureBased'></div>
      <div className="intro-wrap">
        <h2>Nature Based Solutions</h2>
        <p>
          <br></br>
          <br></br>
          We tackle socio-environmental issues by leveraging nature to address various issues. 
          Our solutions aim to safeguard biodiversity and reduce barriers to good health and well-being. 
          <br></br>
          <br></br>
          Our current nature based solutions project target sanitation, as it is a major contributor to
          the overall public health in our partner community. Houses still lack toilets or proper waste 
          collection sites. We plan to implement decentralised wastewater treatment projects that use 
          low-cost solutions to improve sanitation in the community. We install decentralised wastewater
          treatment that can treat black water thereby reducing barriers to good health and well-being
          <br></br>
          <br></br>

          We will begin implementing the Evapotranspiration Tanks in Nigeria this year by building a 
          proof of concept. With your support, you will assist us to implement theoretical and practical
          workshops on Evapotranspiration Tanks for black water treatment in the communities we serve 
          in Nigeria. 
          <br></br>
          <br></br>
          <form className="paypalBtn" action="https://www.paypal.com/donate" method="post" target="_blank">
            <input type="hidden" name="campaign_id" value="C4JFWHMB7KMZU" />
            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
            <img alt="" border="0" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" height="1" />
          </form>

          <br></br>
          For more information on the progress of this project, please follow our social media pages. 



        </p>

      </div>
      
        
    </>
    
  )
}

export default NatureBasedSo
